// Copyright 2025-2026 Florian Gallon. All Rights reserved.

export default function HowItWorks({ isFr }) {
  const steps = isFr
    ? [
        {
          title: 'Mettez en place en 5 minutes',
          body: 'Créez votre compte, ajoutez le nom de votre boulangerie et vos points de vente (domicile, marchés, boutique). Ajoutez vos produits et liez-les à vos recettes. Votre boutique en ligne est créée automatiquement à votrenom.digi-bakery.com.',
        },
        {
          title: 'Partagez votre boutique et prenez les commandes',
          body: 'Partagez le lien de votre boutique par réseaux sociaux, e-mail ou depuis votre site actuel. Les clients commandent en ligne 24h/24, ou vous saisissez les commandes pour eux. Digi-Bakery calcule vos besoins de production.',
        },
        {
          title: 'Cuisez, suivez, livrez',
          body: 'Suivez votre plan de production, tracez vos ingrédients, livrez vos commandes. Tout est enregistré pour la conformité. Vous vous concentrez sur la cuisson.',
        },
      ]
    : [
        {
          title: 'Set up in 5 minutes',
          body: 'Create your account, add your bakery name and your selling points (home, markets, shop). Add your products and link them to recipes. Your online shop is created automatically at yourname.digi-bakery.com.',
        },
        {
          title: 'Share your shop and take orders',
          body: 'Share your shop link over social media, email or from your existing site. Customers order online around the clock, or you enter orders for them. Digi-Bakery works out your production needs.',
        },
        {
          title: 'Bake, track, deliver',
          body: 'Follow your production plan, trace your ingredients, deliver your orders. Everything is recorded for compliance. You focus on baking.',
        },
      ];

  return (
    <section className="dbk-section dbk-section--line">
      <div className="dbk-wrap">
        <div className="dbk-head">
          <h2 className="dbk-h2">{isFr ? 'Comment ça marche' : 'How it works'}</h2>
          <p className="dbk-lede">
            {isFr ? 'Trois étapes. Pas besoin d’être un expert en informatique.' : 'Three steps. No tech skills needed.'}
          </p>
        </div>

        <ol className="dbk-steps" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {steps.map((s, i) => (
            <li key={s.title}>
              <div className="dbk-step__n">{i + 1}</div>
              <h3 className="dbk-h3 dbk-step__title">{s.title}</h3>
              <p className="dbk-step__body">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
